// A hard-coded period + loop used by the engine lab page (E1) before real data exists.
import { makePeriodDef, type LoopData, type NoteEvent, type PeriodDef } from "@eb/shared";

export const DEMO_PERIOD: PeriodDef = makePeriodDef({
  day: 0,
  key: { tonic: 9, mode: "minor" },
  kit: "jungle",
  instruments: { bass: "ladder-bass", harmony: "chorus-pad", lead: "deep-organ" },
  fx: { reverbSize: 0.6, delayTicks: 720 },
  seed: 42,
});

export function demoLoop(): LoopData {
  const ev: NoteEvent[] = [];
  const add = (tick: number, pad: number, note: number, velocity: number, len: number) =>
    ev.push({ tick, pad, note, velocity, length_ticks: len });
  const chords = [
    [57, 60, 64],
    [53, 57, 60],
    [48, 52, 55],
    [55, 59, 62],
  ];
  const bass = [33, 29, 36, 31];
  for (let bar = 0; bar < 8; bar++) {
    const b = bar * 3840;
    add(b, 0, 60, 118, 240);
    add(b + 1680, 0, 60, 96, 240);
    add(b + 2400, 0, 60, 104, 240);
    add(b + 960, 1, 60, 110, 240);
    add(b + 2880, 1, 60, 112, 240);
    for (let s = 0; s < 16; s += 2) add(b + s * 240, 4, 60, s % 4 === 0 ? 92 : 64, 120);
    const c = chords[Math.floor(bar / 2) % 4];
    if (bar % 2 === 0) for (const n of c) add(b, 17, n, 76, 7200);
    const root = bass[Math.floor(bar / 2) % 4];
    add(b, 16, root, 110, 700);
    add(b + 1440, 16, root, 92, 400);
    add(b + 2400, 16, root + 12, 100, 400);
    if (bar % 2 === 1) [76, 72, 69, 72].forEach((n, i) => add(b + i * 960, 18, n, 84, 600));
  }
  return { events: ev, mix: [] };
}
